// A single destination: never retry authenticated requests against another host.
export function resolveApiBase(env) {
  const development = env.NODE_ENV === 'development' || env.NODE_ENV === 'test';
  const configured = env.REACT_APP_API_BASE_URL || (development && env.REACT_APP_WINNING_PRODUCTS_API_URL
    ? env.REACT_APP_WINNING_PRODUCTS_API_URL.replace(/\/winning-products\/?$/, '') : '');
  if (!configured && !development) throw new Error('REACT_APP_API_BASE_URL is required for production.');
  let url;
  try { url = new URL(configured || 'http://localhost:3001'); }
  catch { throw new Error('Invalid REACT_APP_API_BASE_URL.'); }
  const host = url.hostname.toLowerCase().replace(/\.$/, '');
  const local = host === 'localhost' || host.endsWith('.localhost') || host.endsWith('.local') ||
    host.startsWith('[') || /^\d+\.\d+\.\d+\.\d+$/.test(host) || host.endsWith('.internal');
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password ||
      url.search || url.hash || url.pathname !== '/' ||
      (!development && (url.protocol !== 'https:' || local))) {
    throw new Error('REACT_APP_API_BASE_URL must be a safe HTTPS origin in production.');
  }
  return url.origin;
}
export const API_BASE_CANDIDATES = [resolveApiBase(process.env)];
